import { formatISO } from 'date-fns';
import { handleJSON, stringifyEncodeParams } from '@/utils/fetch-utils';
import { headers } from './index';

const { LIVE_INSTRUCTION_API_URL } = process.env;
const baseApiUrl = `${LIVE_INSTRUCTION_API_URL}/v0/teacher/calendar/avail`;
const adminApiUrl = `${LIVE_INSTRUCTION_API_URL}/v0/admin/calendar/avail`;

export default {
  endpoints: {
    tutorCalendar: query => `${baseApiUrl}/${query}`,
    tutorCalendarBase: `${baseApiUrl}/`,
    tutorCalendarReplicate: `${baseApiUrl}/replicate/`,
    adminTutorCalendarBase: `${adminApiUrl}`,
    adminCalendarReplicate: `${adminApiUrl}/replicate`,
  },

  addSlots(start, duration, timezone, mail, orgId, isAdmin) {
    const endpoint = isAdmin ? this.endpoints.adminTutorCalendarBase : this.endpoints.tutorCalendarBase;

    const body = {
      start_at: formatISO(start),
      teacher_timezone: timezone,
      duration_minutes: duration,
      teacher_hashed_email: mail,
      organization_id: orgId,
    };

    const options = {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(body),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  deleteSlots(start, duration, mail) {
    const options = {
      method: 'DELETE',
      headers: headers(),
    };
    const params = {
      start_at: start,
      duration_minutes: duration,
      teacher_hashed_email: mail,
    };

    const query = stringifyEncodeParams(params);
    const endpoint = this.endpoints.tutorCalendar(query);

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchSlots(start, end, mail) {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const params = {
      start_at: formatISO(start),
      end_at: formatISO(end),
      teacher_hashed_email: mail,
    };

    const query = stringifyEncodeParams(params);
    const endpoint = this.endpoints.tutorCalendar(query);

    return fetch(endpoint, options).then(handleJSON);
  },

  replicateWeeks(weeks, start, timezone, email, organizationId, isAdmin) {
    const endpoint = isAdmin ? this.endpoints.adminCalendarReplicate : this.endpoints.tutorCalendarReplicate;

    const body = {
      weeks_to_replicate: weeks,
      start_week: formatISO(start),
      teacher_timezone: timezone,
      teacher_hashed_email: email,
      organization_id: organizationId,
    };

    const options = {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(body),
    };

    return fetch(endpoint, options).then(handleJSON);
  },
};
